import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideBusiness() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="business__wraper">

        {/* 主催事業メニュー */}
        <div className="business__menu-container">
          <h1 className="business__menu-heading">主催事業</h1>
          <ul className="business__menu-list">
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_1'>
                <img className="business__menu-img" src="/images/business/business_menu_01.jpg" alt="八戸うみねこマラソン全国大会" />
                <p className="business__menu-name">八戸うみねこ<br className="br-sp" />マラソン全国大会</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_2'>
                <img className="business__menu-img" src="/images/business/business_menu_02.jpg" alt="八戸リレーマラソン" />
                <p className="business__menu-name">八戸リレー<br className="br-sp" />マラソン</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_3'>
                <img className="business__menu-img" src="/images/business/business_menu_03.jpg" alt="リクルートラウンジ" />
                <p className="business__menu-name">リクルート<br className="br-sp" />ラウンジ</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_12'>
                <img className="business__menu-img" src="/images/business/business_menu_12.jpg" alt="ビブリオバトル" />
                <p className="business__menu-name">ビブリオ<br className="br-sp" />バトル</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_4'>
                <img className="business__menu-img" src="/images/business/business_menu_04.jpg" alt="夏休み学びパーク" />
                <p className="business__menu-name">夏休み<br className="br-sp" />学びパーク</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_5'>
                <img className="business__menu-img" src="/images/business/business_menu_05.jpg" alt="こども絵画コンクール" />
                <p className="business__menu-name">こども絵画<br className="br-sp" />コンクール</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_6'>
                <img className="business__menu-img" src="/images/business/business_menu_06.jpg" alt=">民謡・お笑い夢の祭典" />
                <p className="business__menu-name">民謡・お笑い<br className="br-sp" />夢の祭典</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_7'>
                <img className="business__menu-img" src="/images/business/business_menu_07.jpg" alt="北奥羽囲碁名人戦" />
                <p className="business__menu-name">北奥羽囲<br className="br-sp" />碁名人戦</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_8'>
                <img className="business__menu-img" src="/images/business/business_menu_08.jpg" alt="北奥羽団体囲碁大会" />
                <p className="business__menu-name">北奥羽団体<br className="br-sp" />囲碁大会</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_9'>
                <img className="business__menu-img" src="/images/business/business_menu_09.jpg" alt="コラムに挑戦「私の天鐘」" />
                <p className="business__menu-name">コラムに挑戦<br className="br-sp" />「私の天鐘」</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_10'>
                <img className="business__menu-img" src="/images/business/business_menu_10.jpg" alt="新聞感想文コンクール" />
                <p className="business__menu-name">新聞感想文<br className="br-sp" />コンクール</p>
              </a>
            </li>
            <li className="business__menu-item">
              <a className="business__menu-link" href='#event_0'>
                <img className="business__menu-img" src="/images/business/business_menu_11.jpg" alt="リアル体験事業" />
                <p className="business__menu-name">リアル<br className="br-sp" />体験事業</p>
              </a>
            </li>
          </ul>
        </div>

        {/* リアル体験事業とは */}
        <a id="event_0" class="anchor"></a>
        <section className="business__real-section business__section">
          <div className="business__real-container">
            <h2 className="business__section-heading">リアル体験事業とは</h2>
            <p className="business__real-intro business__text">「趣味を楽しみたい」「芸術に感動したい」「地域のことを語らいたい」─。日常生活の中に少しときめきの〝スパイス〟を加えるような企画があったらいいと思いませんか。私たちは年間を通して、気軽に参加できるさまざまな学びや感動の場をつくり、皆さまの暮らしがより豊かになるお手伝いをしたいと考えています。</p>

            <div className="business__real-list">
              <article className="business__real-item">
                <img className="business__real-ill" src="/images/business/business_real_ill_01.jpg" alt="楽しむくらし" />
                <h3 className="business__real-heading">感動するくらし</h3>
                <p className="business__real-text business__text">
                  国内外で活躍するアーティストの生演奏や芸術作品に触れる時間は心を潤わせます。ピアノ演奏「旅する音楽」や、ジャズや津軽三味線、地元アイドルのライブ、時には落語など素敵なアーティストと過ごす豊かな時間で、日々の暮らしに新しい感動を。
                </p>
                <div className="business__real-img-container">
                  <img className="business__real-img" src="/images/business/business_real_01.jpg" alt="感動するくらし" />
                  <img className="business__real-img" src="/images/business/business_real_02.jpg" alt="感動するくらし" />
                </div>
              </article>

              <article className="business__real-item">
                <img className="business__real-ill" src="/images/business/business_real_ill_02.jpg" alt="聴いて考えるくらし" />
                <h3 className="business__real-heading">聴いて考えるくらし</h3>
                <p className="business__real-text business__text">
                  「新聞に掲載された人の話を直接聴いてみたい」「新聞に掲載されていた地域の話題や課題についてもっと聴いてみたい。」―そんな声に応えます。記事の執筆者や有識者、スポーツ指導者らにより活字がリアルになるトーキングイベントで、暮らしに新しい学びを。
                </p>
                <div className="business__real-img-container">
                  <img className="business__real-img" src="/images/business/business_real_03.jpg" alt="聴いて考えるくらし" />
                  <img className="business__real-img" src="/images/business/business_real_04.jpg" alt="聴いて考えるくらし" />
                </div>
              </article>

              <article className="business__real-item">
                <img className="business__real-ill" src="/images/business/business_real_ill_03.jpg" alt="楽しむくらし" />
                <h3 className="business__real-heading">楽しむくらし</h3>
                <p className="business__real-text business__text">
                  「スマホが簡単に使えるようになりたい」「紙面で見たイベントに参加したい」―そんな声に応えます。「昨日よりちょっと新しい自分になれた」と言ってもらえるような、暮らしのお役に立てる講座などで、日々の暮らしに新しい楽しみを。
                </p>
                <div className="business__real-img-container">
                  <img className="business__real-img" src="/images/business/business_real_05.jpg" alt="楽しむくらし" />
                  <img className="business__real-img" src="/images/business/business_real_06.jpg" alt="楽しむくらし" />
                </div>
              </article>
            </div>
          </div>
        </section>

        {/* 年間イベントカレンダー */}
        <a id="event-calender" className="anchor"></a>
        <section className="business__cal-section business__section">
          <h2 className="business__cal-heading business__section-heading">年間イベントカレンダー</h2>
          <p className="business__cal-info">※状況によって中止または日程変更になる<br className="br-sp" />可能性があります</p>
          <div className="business__cal-flow">
            <ul className="business__cal-list">
              <li className="business__cal-item">
                <dl className="business__cal-item-wrapper fb-center">
                  <dt className="business__cal-title">2月</dt>
                  <dd className="business__cal-content">
                    <ul className="bullet-list">
                      <li className="bullet-list__item">こども絵画コンクール（審査・表彰式）</li>
                      <li className="bullet-list__item">コラムに挑戦「私の天鐘」（表彰式）</li>
                    </ul>
                  </dd>
                </dl>
              </li>
              <li className="business__cal-item">
                <dl className="business__cal-item-wrapper fb-center">
                  <dt className="business__cal-title">5月</dt>
                  <dd className="business__cal-content">
                    <ul className="bullet-list">
                      <li className="bullet-list__item">八戸うみねこマラソン全国大会（22年度は中止）</li>
                      <li className="bullet-list__item">北奥羽囲碁名人戦予選会</li>
                      <li className="bullet-list__item">大学進学説明会</li>
                    </ul>
                  </dd>
                </dl>
              </li>
              <li className="business__cal-item">
                <dl className="business__cal-item-wrapper fb-center">
                  <dt className="business__cal-title">6月</dt>
                  <dd className="business__cal-content">
                    <ul className="bullet-list">
                      <li className="bullet-list__item">はちのへ将棋まつり</li>
                    </ul>
                  </dd>
                </dl>
              </li>
              <li className="business__cal-item">
                <dl className="business__cal-item-wrapper">
                  <dt className="business__cal-title">7月</dt>
                  <dd className="business__cal-content">
                    <ul className="bullet-list">
                      <li className="bullet-list__item">青森県南中学校選抜野球大会</li>
                      <li className="bullet-list__item">北奥羽団体囲碁大会</li>
                      <li className="bullet-list__item">久慈地区家庭婦人バレーボール大会</li>
                      <li className="bullet-list__item">
                        デーリー東北カップ八戸港<br />
                        カッターレース（22年度は中止）
                      </li>
                    </ul>
                  </dd>
                </dl>
              </li>
              <li className="business__cal-item">
                <dl className="business__cal-item-wrapper fb-center">
                  <dt className="business__cal-title">8月</dt>
                  <dd className="business__cal-content">
                    <ul className="bullet-list">
                      <li className="bullet-list__item">北奥羽囲碁名人戦</li>
                      <li className="bullet-list__item">リクルートラウンジ八戸①</li>
                      <li className="bullet-list__item">八戸納涼盆踊り大会（22年度は中止）</li>
                    </ul>
                  </dd>
                </dl>
              </li>
              <li className="business__cal-item">
                <dl className="business__cal-item-wrapper fb-center">
                  <dt className="business__cal-title">
                    9月
                  </dt>
                  <dd className="business__cal-content">
                    <ul className="bullet-list">
                      <li className="bullet-list__item">リクルートラウンジ八戸②</li>
                      <li className="bullet-list__item">リクルートラウンジ東京</li>
                      <li className="bullet-list__item">ビブリオバトル予選会（調整中）</li>
                    </ul>
                  </dd>
                </dl>
              </li>
              <li className="business__cal-item">
                <dl className="business__cal-item-wrapper">
                  <dt className="business__cal-title">
                    10月
                  </dt>
                  <dd className="business__cal-content">
                    <ul className="bullet-list">
                      <li className="bullet-list__item">北奥羽将棋名人戦</li>
                      <li className="bullet-list__item">北奥羽シニア将棋名人戦</li>
                      <li className="bullet-list__item">北奥羽こども将棋大会</li>
                      <li className="bullet-list__item">北奥羽短歌大会</li>
                      <li className="bullet-list__item">八戸リレーマラソン</li>
                      <li className="bullet-list__item">大学OB対抗ゴルフ大会</li>
                    </ul>
                  </dd>
                </dl>
              </li>
              <li className="business__cal-item">
                <dl className="business__cal-item-wrapper">
                  <dt className="business__cal-title">11月</dt>
                  <dd className="business__cal-content">
                    <ul className="bullet-list">
                      <li className="bullet-list__item">デーリー東北新聞社旗少年サッカー大会</li>
                      <li className="bullet-list__item">職域愛好団体対抗将棋大会（22年度ははちのへ将棋まつりと併せて開催）</li>
                      <li className="bullet-list__item">北奥羽俳句大会</li>
                      <li className="bullet-list__item">民謡・お笑い夢の祭典</li>
                      <li className="bullet-list__item">新聞感想文コンクール（表彰式）</li>
                      <li className="bullet-list__item">デーリー東北新聞社杯ママさんバレーボール大会</li>
                      <li className="bullet-list__item">ビブリオバトル決勝戦（調整中）</li>
                    </ul>
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </section>

        {/* イベント紹介 */}
        <section className="business__event-section business__section">
          <div className="business__event-container">
            <h2 className="business__section-heading business__evnet-heading">イベント紹介</h2>


            {/* 01 八戸うみねこマラソン全国大会 */}
            <a id="event_1" class="anchor"></a>
            <article className="business__event-item bg-odd">
              <h3 className="business__event-name">01  八戸うみねこマラソン全国大会</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  北奥羽地方の春の風物詩として定着しており、毎年全国各地の市民ランナーが集い、「走るあなたが主役です！」をテーマに健脚を競います。<br />
                  <br />
                  デーリー東北新聞社と八戸市陸上競技協会が主催して毎年５月、青森県八戸市の八戸水産公社付近を発着点とするコースで開催しています。種目は日本陸上競技連盟公認コースのハーフマラソン（２１．０９７５キロ）と１０キロのほか、５キロと３キロがあり、男女別・年齢区分による２１部門です。ハーフ種目では、通称「うみねこライン」を通し、白浜海水浴場を折り返す潮騒コースを走ります。各部門８位まで表彰します。
                </p>
                <img className="business__event-img" src="/images/business/business_event_01.jpg" alt="八戸うみねこマラソン全国大会" />
              </div>
              <div className="business__event-cancel-box">
                <h4 className="business__event-cancel-name">第42回八戸うみねこマラソン全国大会、４年ぶり開催</h4>
                <p className="business__event-cancel-text business__text">
                　デーリー東北新聞社と八戸市陸上競技協会は、「第４２回八戸うみねこマラソン全国大会」を５月２１日（日）午前８時１０分（競技開始同９時）から、同市新湊３丁目の旧八戸水産公社前を発着点とするコースで開催します。<br />
                　新型コロナウイルスの影響で２０２０年の第３９回大会から３大会連続で中止しており、今回は４年ぶりの開催です。<br />
                　公益財団法人日本陸上競技連盟の公認大会です。種目は日本陸連公認コースのハーフマラソン（２１・０９７５㌔）と１０㌔のほか、５㌔、３㌔で、男女別、年齢区分による２１部門です。ハーフは県道「うみねこライン」を通り、白浜海水浴場を折り返す潮騒コースを走ります。種目、コースとも変更はありません。<br />
                　今回からハーフと１０㌔の給水所を増設するほか、完走者に配る完走証をウェブでも発行します。<br />
                　表彰は各部門８位まで。第３８回大会で創設した「チェコ共和国杯・人見絹枝賞」は、３㌔タイムなしを除く２０部門のうち、当日抽選で選んだ種目の優勝者に贈呈します。<br />
                　参加申し込みはインターネット（ＲＵＮＴＥＳ）で２月１４日（火）から受け付けます。締め切りは３月１７日（金）。<br />
                　大会パンフレットは２月６日からデーリー東北イベントガイドで公開します。<br />
                　コース沿線、周辺の皆さまには交通規制などでご迷惑をおかけすることになりますが、ご理解とご協力、ご支援をお願いします。<br />
                <br />
                </p>
                <p className="business__event-signature business__text">
                  デーリー東北新聞社<br />
                  八戸市陸上競技協会<br />
                </p>
              </div>
              <div className="business__event-btn-box">
                <a className="business__event-link-btn--two" href="https://www.daily-tohoku.news/umineko-marathon" target="_blank">うみねこマラソン 第40回詳細</a>
                <a className="business__event-link-btn--two" href="https://www.daily-tohoku.news/umineko-marathon-39" target="_blank">うみねこマラソン 第39回詳細</a>
              </div>
            </article>

            {/* 02  八戸リレーマラソン */}
            <a id="event_2" class="anchor"></a>
            <article className="business__event-item bg-even">
              <h3 className="business__event-name">02  八戸リレーマラソン</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  ６～１３人で構成する各チームが、たすきをつないで長距離完走を目指します。<br />
                  <br />
                  コースは１周１．６キロ。４２．１９５キロを走る「フルリレーマラソン」は、（１）男子（２）男女混合（３）職場対抗の３部門、２１．０９７５キロの「ハーフリレーマラソン」は、（４）一般（５）女子（６）マスターズ（７）中学生（８）小学生（９）ファミリーの６部門で実施。お祭りのような雰囲気でランニングが楽しめます。<br />
                  <a className="business__event-link-btn" href="https://www.daily-tohoku.news/relay" target="_blank">八戸リレーマラソン 第７回詳細</a>
                </p>
                <img className="business__event-img" src="/images/business/business_event_02.jpg" alt="八戸リレーマラソン" />
              </div>
              {/*
              <div className="business__event-cancel-box">
                <h4 className="business__event-cancel-name">第６回八戸リレーマラソン中止</h4>
                <p className="business__event-cancel-text business__text">
                  2021年秋に開催を予定していた第6回八戸リレーマラソンin東運動公園（デーリー東北新聞社、エスプロモ主催）は、新型コロナウイルス感染症の収束の見通しが立たないため中止とさせていただきます。参加を検討していただいた皆さまには大変ご迷惑をお掛けしますが、ご理解いただきますようお願い申し上げます。
                </p>
                <p className="business__event-signature business__text">
                  デーリー東北新聞社<br />
                  エスプロモ株式会社
                </p>
              </div>
              */}
              {/*
              <div className="business__event-btn-box">
                <a className="business__event-link-btn--two" href="https://www.daily-tohoku.company/relay-info" target="_blank">八戸リレーマラソン 第5回詳細</a>
                <a className="business__event-link-btn--two" href="https://www.daily-tohoku.news/relay" target="_blank">八戸リレーマラソン 第４回詳細</a>
              </div>
              */}
            </article>

            {/* 03  リクルートラウンジ */}
            <a id="event_3" class="anchor"></a>
            <article className="business__event-item bg-odd">
              <h3 className="business__event-name">03  リクルートラウンジ</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  地方での人口減と少子高齢化が急激に進む今、若者の地元定着は地域経済の存続を左右する喫緊の課題です。そこで、弊社は２０１８年度から、高校生以上の市民に広く地元企業を知ってもらうため、新聞とウェブ、企業内容説明会をセットにした「デーリー東北リクルートラウンジ」をスタートさせました。<br />
                  <br />
                  進学・就職志望にかかわらず、地元企業の人事担当者と直接面談し、「働くこと」へのイメージを持ってもらうと同時に、多種多様な地元企業を知ってもらうことを狙いとしています。八戸の企業の魅力を伝え、多くの若者が地元に定着することを願っています。<br />
                  <a className="business__event-link-btn" href="https://www.recruit-lounge.com/" target="_blank">詳 細</a>
                </p>
                <img className="business__event-img" src="/images/business/business_event_03.jpg" alt="リクルートラウンジ" />
              </div>
            </article>

            {/* 04  ビブリオバトル */}
            <a id="event_12" class="anchor"></a>
            <article className="business__event-item bg-even">
              <h3 className="business__event-name">04  ビブリオバトル</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  「ビブリオバトル」とは、お気に入りの本を持ち寄って紹介し合い、みんなで一番読みたくなった本を選ぶ新しい書評コミュニケーションゲームです。<br />
                  <br />
                  「ビブリオバトル in 八戸」では、高校生、大学生・一般の２部門で予選会を勝ち抜いた発表者が決勝戦に進み、“全世代対決”で青森、岩手の「チャンプ本」を決定します。
                  <a className="business__event-link-btn" href="http://feature.daily-tohoku.co.jp/biblio/2022/biblio.htm?fbclid=IwAR1IEINRb1MemT7Dbk7_MnaDvzYGB0S29IDJ4ao5g-kCXGrEGKVsiImUcXQ" target="_blank">第9回詳細</a>
                </p>
                <img className="business__event-img" src="/images/business/business_event_12.jpg" alt="ビブリオバトル" />
              </div>
            </article>

            {/* 05  夏休み学びパーク */}
            <a id="event_4" class="anchor"></a>
            <article className="business__event-item bg-odd">
              <h3 className="business__event-name">05  夏休み学びパーク</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  子どもたちの考える力を育み、夏休みの宿題や自由研究に生かしてもらおうと、NPO法人はちのへ未来ネットと協力して開催しています。<br />
                  <br />
                  これまでに各地の地方紙を読み比べて気になった記事をまとめて新聞を作る「まわしよみ新聞」作りや本社印刷工場の見学、図画講座などを行いました。
                  <a className="business__event-link-btn" href="https://www.daily-tohoku.news/manabi-park" target="_blank">詳 細</a>
                </p>
                <img className="business__event-img" src="/images/business/business_event_04.jpg" alt="夏休み学びパーク" />
              </div>
            </article>

            {/* 06  こども絵画コンクール */}
            <a id="event_5" class="anchor"></a>
            <article className="business__event-item bg-even">
              <h3 className="business__event-name">06  こども絵画コンクール</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  幼児～中学生までの感性豊かな作品を募集し、入賞作品を表彰します。作品総数は毎回２０００点を超え、デーリー東北ホールで上位作品の展示会も開いています。<br />
                  <br />
                  絵画への取り組みを通じて、感性豊かな子どもの育成を目指します。<br />
                  <br />
                  対象は青森、岩手両県内の３歳以上の幼児から中学生まで（特別支援学級を含む）。テーマは自由です。<br />
                  <a className="business__event-link-btn" href="https://www.daily-tohoku.company/guide-business/childpainting">詳 細</a>
                </p>
                <img className="business__event-img" src="/images/business/business_event_05.jpg" alt="子ども絵画コンクール" />
              </div>
            </article>

            {/* 07  民謡・お笑い夢の祭典 */}
            <a id="event_6" class="anchor"></a>
            <article className="business__event-item bg-odd">
              <h3 className="business__event-name">07  民謡・お笑い夢の祭典</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  地元を中心に活躍する歌手や歴代の青森県民謡王座、手踊り名人、八戸市内の市内の社中などらが一堂に会し、華やかな舞台を繰り広げます。<br />
                  <br />
                  １９８３年から続く人気イベントです。毎年、市内外から大勢のファンが詰めかけ、出演者の自慢の歌声や踊りで大盛り上がりを見せます。
                </p>
                <img className="business__event-img" src="/images/business/business_event_06.jpg" alt="民謡・お笑い夢の祭典" />
              </div>
            </article>

            {/* 08  北奥羽囲碁名人戦 */}
            <a id="event_7" class="anchor"></a>
            <article className="business__event-item bg-even">
              <h3 className="business__event-name">08  北奥羽囲碁名人戦</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  北奥羽地方在住の有段者（五段以上）が出場し、リーグ戦と代表決定戦による予選と、総当たりの本戦で名人位を懸けて熱戦を繰り広げます。<br />
                  <br />
                  名人位獲得者は、陸奥新報社主催の「みちのく囲碁最高位決定戦」優勝者と特別対局を行い、その熱戦譜は新年１月の本紙囲碁欄に掲載されます。
                </p>
                <img className="business__event-img" src="/images/business/business_event_07.jpg" alt="北奥羽囲碁名人戦" />
              </div>
            </article>

            {/* 09  北奥羽団体囲碁大会 */}
            <a id="event_8" class="anchor"></a>
            <article className="business__event-item bg-odd">
              <h3 className="business__event-name">09  北奥羽団体囲碁大会</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  青森県南、岩手県北両地方から３人編成のチームが出場し、頂点を争う大会です。<br />
                  <br />
                  Ａ（有段者の部）、Ｂ（三段以下の部）の２クラスに分かれ、５局戦います。高校生や級位の子どもたちも多数参加しています。
                </p>
                <img className="business__event-img" src="/images/business/business_event_08.jpg" alt="北奥羽団体囲碁大会" />
              </div>
            </article>

            {/* 10  コラムに挑戦「私の天鐘」 */}
            <a id="event_9" class="anchor"></a>
            <article className="business__event-item bg-even">
              <h3 className="business__event-name">10  コラムに挑戦「私の天鐘」</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  デーリー東北の一面コラム「天鐘」。時事、季節、歴史、身近な出来事など、書き手の感じたこと、伝えたいことを、決められた文字数の中で分かりやすくまとめています。<br />
                  <br />
                  自由な発想で、あなたの考えをコラムにしてみませんか？<br />
                  <a className="business__event-link-btn" href="https://www.daily-tohoku.news/mytensho" target="_blank">詳 細</a>
                </p>
                <img className="business__event-img" src="/images/business/business_event_09.jpg" alt="コラムに挑戦「私の天鐘」" />
              </div>
            </article>

            {/* 11  新聞感想文コンクール */}
            <a id="event_10" class="anchor"></a>
            <article className="business__event-item bg-odd">
              <h3 className="business__event-name">11  新聞感想文コンクール</h3>
              <div className="business__event-inner">
                <p className="business__event-text business__text">
                  デーリー東北新聞社は、子どもの頃から新聞に親しみ、読解力や表現力を高めることを目的に、「デーリー東北　新聞感想文コンクール」を実施しています。<br />
                  <br />
                  デーリー東北に掲載された記事を読んでの感想を、小学生から高校生までの計４部門で募集します。
                  <a className="business__event-link-btn" href="https://www.daily-tohoku.company/event/newspaperreport">詳 細</a>
                </p>
                <img className="business__event-img" src="/images/business/business_event_10.jpg" alt="コラムに挑戦「私の天鐘」" />
              </div>
            </article>
          </div>
        </section>

      </div>
    </div>
  );
}

export default GuideBusiness;
